<template lang="pug">
div
  ul#gameresulttab.nav.nav-tabs(role='tablist')
    li.nav-item(v-if="showActionButton('dailystatement')" @click="refresh('dailystatement')")
      a#dailystatement-tab.nav-link(:class="{ 'active': currTab == 'dailystatement' }" data-toggle='tab' href='#dailystatement-content' role='tab' aria-controls='dailystatement' aria-selected='false') {{ $t("ui.daily_statement") }}
    li.nav-item(v-if="showActionButton('platformwinlose')" @click="refresh('platformwinlose')")
      a#platformwinlose-tab.nav-link(:class="{ 'active': currTab == 'platformwinlose' }" data-toggle='tab' href='#platformwinlose-content' role='tab' aria-controls='platformwinlose' aria-selected='false') {{ $t("ui.platform_winlose") }}
    li.nav-item(v-if="showActionButton('providerwinlosemember')" @click="refresh('providerwinlosemember')")
      a#providerwinlosemember-tab.nav-link(:class="{ 'active': currTab == 'providerwinlosemember' }" data-toggle='tab' href='#providerwinlosemember-content' role='tab' aria-controls='providerwinlosemember' aria-selected='false') {{ $t("ui.provider_winlose_member") }}
    li.nav-item(v-if="showActionButton('refereelist')" @click="refresh('refereelist')")
      a#refereelist-tab.nav-link(:class="{ 'active': currTab == 'refereelist' }" data-toggle='tab' href='#refereelist-content' role='tab' aria-controls='refereelist' aria-selected='false') {{ $t("ui.referee_list") }}
    li.nav-item(v-if="showActionButton('rebatemember')" @click="refresh('rebatemember')")
      a#rebatemember-tab.nav-link(:class="{ 'active': currTab == 'rebatemember' }" data-toggle='tab' href='#rebatemember-content' role='tab' aria-controls='rebatemember' aria-selected='false') {{ $t("ui.rebate_member") }}
    li.nav-item(v-if="showActionButton('gameresultslots')" @click="refresh('gameresultslots')")
      a#gameresultslots-tab.nav-link(:class="{ 'active': currTab == 'gameresultslots' }" data-toggle='tab' href='#gameresultslots-content' role='tab' aria-controls='gameresultslots' aria-selected='false') {{ $t("ui.game_result_slots") }}
    li.nav-item(v-if="showActionButton('gameresultlivecasino')" @click="refresh('gameresultlivecasino')")
      a#gameresultlivecasino-tab.nav-link(:class="{ 'active': currTab == 'gameresultlivecasino' }" data-toggle='tab' href='#gameresultlivecasino-content' role='tab' aria-controls='gameresultlivecasino' aria-selected='false') {{ $t("ui.game_result_livecasino") }}
    li.nav-item(v-if="showActionButton('gameresultsportsbook')" @click="refresh('gameresultsportsbook')")
      a#gameresultsportsbook-tab.nav-link(:class="{ 'active': currTab == 'gameresultsportsbook' }" data-toggle='tab' href='#gameresultsportsbook-content' role='tab' aria-controls='gameresultsportsbook' aria-selected='false') {{ $t("ui.game_result_sportsbook") }}
    li.nav-item(v-if="showActionButton('gameresultcockfight')" @click="refresh('gameresultcockfight')")
      a#gameresultcockfight-tab.nav-link(:class="{ 'active': currTab == 'gameresultcockfight' }" data-toggle='tab' href='#gameresultcockfight-content' role='tab' aria-controls='gameresultcockfight' aria-selected='false') {{ $t("ui.game_result_cockfight") }}
    li.nav-item(v-if="showActionButton('gameresultrescue')" @click="refresh('gameresultrescue')")
      a#gameresultrescue-tab.nav-link(:class="{ 'active': currTab == 'gameresultrescue' }" data-toggle='tab' href='#gameresultrescue-content' role='tab' aria-controls='gameresultrescue' aria-selected='false') {{ $t("ui.game_result_rescue") }}
    li.nav-item(v-if="showActionButton('gameresultreward')" @click="refresh('gameresultreward')")
      a#gameresultreward-tab.nav-link(:class="{ 'active': currTab == 'gameresultreward' }" data-toggle='tab' href='#gameresultreward-content' role='tab' aria-controls='gameresultreward' aria-selected='false') {{ $t("ui.game_result_reward") }}
    li.nav-item(v-if="showActionButton('gameresultfreeslots')" @click="refresh('gameresultfreeslots')")
      a#gameresultfreeslots-tab.nav-link(:class="{ 'active': currTab == 'gameresultfreeslots' }" data-toggle='tab' href='#gameresultfreeslots-content' role='tab' aria-controls='gameresultfreeslots' aria-selected='false') {{ $t("ui.game_result_free_slots") }}
    li.nav-item(v-if="showActionButton('gameresultothers')" @click="refresh('gameresultothers')")
      a#gameresultothers-tab.nav-link(:class="{ 'active': currTab == 'gameresultothers' }" data-toggle='tab' href='#gameresultothers-content' role='tab' aria-controls='gameresultothers' aria-selected='false') {{ $t("ui.game_result_others") }}
    li.nav-item(v-if="showActionButton('pendingbetlistwbet')" @click="refresh('pendingbetlistwbet')")
      a#pendingbetlistwbet-tab.nav-link(:class="{ 'active': currTab == 'pendingbetlistwbet' }" data-toggle='tab' href='#pendingbetlistwbet-content' role='tab' aria-controls='pendingbetlistwbet' aria-selected='false') {{ $t("ui.pending_bet_list_wbet") }}
    li.nav-item(v-if="showActionButton('pendingbetlist9w') && (isUat == 'true' || ['BDT'].includes(getCurrencyCode))" @click="refresh('pendingbetlist9w')")
      a#pendingbetlist9w-tab.nav-link(:class="{ 'active': currTab == 'pendingbetlist9w' }" data-toggle='tab' href='#pendingbetlist9w-content' role='tab' aria-controls='pendingbetlist9w' aria-selected='false') {{ $t("ui.pending_bet_list_9w") }}
    li.nav-item(v-if="showActionButton('pendingbetlistothers') && !['BDT'].includes(getCurrencyCode)" @click="refresh('pendingbetlistothers')")
      a#pendingbetlistothers-tab.nav-link(:class="{ 'active': currTab == 'pendingbetlistothers' }" data-toggle='tab' href='#pendingbetlistothers-content' role='tab' aria-controls='pendingbetlistothers' aria-selected='false') {{ $t("ui.pending_bet_list_others") }}
    //- li.nav-item(v-if="showActionButton('memberlinkage') && !['BDT'].includes(getCurrencyCode)" @click="refresh('memberlinkage')")
    //-   a#memberlinkage-tab.nav-link(:class="{ 'active': currTab == 'memberlinkage' }" data-toggle='tab' href='#memberlinkage-content' role='tab' aria-controls='memberlinkage' aria-selected='false') {{ $t("ui.member_linkage") }}


  #gameresulttabcontent.tab-content.tab-bordered
    #dailystatement-content.tab-pane.fade(:class="{ 'active show': currTab == 'dailystatement' }" v-if="showActionButton('dailystatement')" role='tabpanel' aria-labelledby='dailystatement-tab')
      dailyStatementTab(ref="dailyStatementTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #platformwinlose-content.tab-pane.fade(:class="{ 'active show': currTab == 'platformwinlose' }" v-if="showActionButton('platformwinlose')" role='tabpanel' aria-labelledby='platformwinlose-tab')
      platformWinLoseTab(ref="platformWinLoseTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #providerwinlosemember-content.tab-pane.fade(:class="{ 'active show': currTab == 'providerwinlosemember' }" v-if="showActionButton('providerwinlosemember')" role='tabpanel' aria-labelledby='providerwinlosemember-tab')
      providerWinLoseMemberTab(ref="providerWinLoseMemberTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab" @redirectReport="redirectReport")
    #refereelist-content.tab-pane.fade(:class="{ 'active show': currTab == 'refereelist' }" v-if="showActionButton('refereelist')" role='tabpanel' aria-labelledby='refereelist-tab')
      refereeListTab(ref="refereeListTab" :member="member" :currTab="currTab")
    #rebatemember-content.tab-pane.fade(:class="{ 'active show': currTab == 'rebatemember' }" v-if="showActionButton('rebatemember')" role='tabpanel' aria-labelledby='rebatemember-tab')
      rebateMemberTab(ref="rebateMemberTab" :memberID="memberID" :currTab="currTab" @redirectReport="redirectReport")
    #gameresultslots-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultslots' }" v-if="showActionButton('gameresultslots')" role='tabpanel' aria-labelledby='gameresultslots-tab')
      gameResultSlotsTab(ref="gameResultSlotsTab" :memberID="memberID" :currTab="currTab")
    #gameresultlivecasino-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultlivecasino' }" v-if="showActionButton('gameresultlivecasino')" role='tabpanel' aria-labelledby='gameresultlivecasino-tab')
      gameResultLivecasinoTab(ref="gameResultLivecasinoTab" :memberID="memberID" :currTab="currTab")
    #gameresultsportsbook-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultsportsbook' }" v-if="showActionButton('gameresultsportsbook')" role='tabpanel' aria-labelledby='gameresultsportsbook-tab')
      gameResultSportsbookTab(ref="gameResultSportsbookTab" :memberID="memberID" :currTab="currTab")
    #gameresultcockfight-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultcockfight' }" v-if="showActionButton('gameresultcockfight')" role='tabpanel' aria-labelledby='gameresultcockfight-tab')
      gameResultCockfightTab(ref="gameResultCockfightTab" :memberID="memberID" :currTab="currTab")
    #gameresultrescue-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultrescue' }" v-if="showActionButton('gameresultrescue')" role='tabpanel' aria-labelledby='gameresultrescue-tab')
      gameResultRescueTab(ref="gameResultRescueTab" :memberID="memberID" :currTab="currTab")
    #gameresultreward-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultreward' }" v-if="showActionButton('gameresultreward')" role='tabpanel' aria-labelledby='gameresultreward-tab')
      gameResultRewardTab(ref="gameResultRewardTab" :memberID="memberID" :currTab="currTab")
    #gameresultfreeslots-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultfreeslots' }" v-if="showActionButton('gameresultfreeslots')" role='tabpanel' aria-labelledby='gameresultfreeslots-tab')
      gameResultFreeSlotsTab(ref="gameResultFreeSlotsTab" :memberID="memberID" :currTab="currTab")
    #gameresultothers-content.tab-pane.fade(:class="{ 'active show': currTab == 'gameresultothers' }" v-if="showActionButton('gameresultothers')" role='tabpanel' aria-labelledby='gameresultothers-tab')
      gameResultOthersTab(ref="gameResultOthersTab" :memberID="memberID" :currTab="currTab")
    
    #pendingbetlistwbet-content.tab-pane.fade(:class="{ 'active show': currTab == 'pendingbetlistwbet' }" v-if="showActionButton('pendingbetlistwbet')" role='tabpanel' aria-labelledby='pendingbetlistwbet-tab')
      pendingBetListWBetTab(ref="pendingBetListWBetTab" :memberID="memberID" :currTab="currTab")
    #pendingbetlist9w-content.tab-pane.fade(:class="{ 'active show': currTab == 'pendingbetlist9w' }" v-if="showActionButton('pendingbetlist9w')  && (isUat == 'true' || ['BDT'].includes(getCurrencyCode))" role='tabpanel' aria-labelledby='pendingbetlist9w-tab')
      pendingBetList9WTab(ref="pendingBetList9WTab" :memberID="memberID" :currTab="currTab")
    #pendingbetlistothers-content.tab-pane.fade(:class="{ 'active show': currTab == 'pendingbetlistothers' }" v-if="showActionButton('pendingbetlistothers') && !['BDT'].includes(getCurrencyCode)" role='tabpanel' aria-labelledby='pendingbetlistothers-tab')
      pendingBetListOthersTab(ref="pendingBetListOthersTab" :memberID="memberID" :currTab="currTab")
    //- #memberlinkage-content.tab-pane.fade(:class="{ 'active show': currTab == 'memberlinkage' }" v-if="showActionButton('memberlinkage') && member != null && !['BDT'].includes(getCurrencyCode)" role='tabpanel' aria-labelledby='memberlinkage-tab')
    //-   memberLinkageTab(ref="memberLinkageTab" :operatorID="operatorID" :memberID="memberID" :memberSecondID="member.second_id" :currTab="currTab")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import dailyStatementTab from "@/components/reportTab/dailyStatementTab.vue";
import platformWinLoseTab from "@/components/reportTab/platformWinLoseTab.vue";
import providerWinLoseMemberTab from "@/components/reportTab/providerWinLoseMemberTab.vue";
import refereeListTab from "@/components/reportTab/refereeListTab.vue";
import gameResultCockfightTab from "@/components/reportTab/gameResultCockfightTab.vue";
import gameResultLivecasinoTab from "@/components/reportTab/gameResultLivecasinoTab.vue";
import gameResultRescueTab from "@/components/reportTab/gameResultRescueTab.vue";
import gameResultSlotsTab from "@/components/reportTab/gameResultSlotsTab.vue";
import gameResultSportsbookTab from "@/components/reportTab/gameResultSportsbookTab.vue";
import gameResultRewardTab from "@/components/reportTab/gameResultRewardTab.vue";
import gameResultFreeSlotsTab from "@/components/reportTab/gameResultFreeSlotsTab.vue";
import gameResultOthersTab from "@/components/reportTab/gameResultOthersTab.vue";
import pendingBetListWBetTab from "@/components/reportTab/pendingBetListWBetTab.vue";
import pendingBetList9WTab from "@/components/reportTab/pendingBetList9WTab.vue";
import pendingBetListOthersTab from "@/components/reportTab/pendingBetListOthersTab.vue";
import rebateMemberTab from "@/components/reportTab/rebateMemberTab.vue";
import memberLinkageTab from "@/components/reportTab/memberLinkageTab.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    dailyStatementTab,
    platformWinLoseTab,
    refereeListTab,
    providerWinLoseMemberTab,
    gameResultCockfightTab,
    gameResultLivecasinoTab,
    gameResultRescueTab,
    gameResultSlotsTab,
    gameResultSportsbookTab,
    gameResultRewardTab,
    gameResultFreeSlotsTab,
    gameResultOthersTab,
    pendingBetListWBetTab,
    pendingBetList9WTab,
    pendingBetListOthersTab,
    rebateMemberTab,
    memberLinkageTab
  },
  props: {
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    },
    member: {
      type: Object
    }
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'dailystatement',
    isUat: config.isUat
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
  },
  mounted: function() {
  },
  destroyed: function() {
    const query = { ...this.$route.query }
    delete query.reportTab

    this.$router
      .replace({ query })
      .catch(err => {
        // Vue Router treats this as a redundant navigation and throws NavigationDuplicated
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'dailystatement':
          this.tabChecking();
          break
        case 'platformwinlose':
          this.currTab = 'platformwinlose'
          this.$nextTick(() => {
            if(this.$refs.platformWinLoseTab) {
              this.$refs.platformWinLoseTab.refresh();
            }
          });
          break
        case 'providerwinlosemember':
          this.currTab = 'providerwinlosemember'
          this.$nextTick(() => {
            if(this.$refs.providerWinLoseMemberTab) {
              this.$refs.providerWinLoseMemberTab.refresh();
            }
          });
          break
        case 'refereelist':
          this.currTab = 'refereelist'
          this.$nextTick(() => {
            if(this.$refs.refereeListTab) {
              this.$refs.refereeListTab.refresh();
            }
          });
          break
        case 'rebatemember':
          this.currTab = 'rebatemember'
          this.$nextTick(() => {
            if(this.$refs.rebateMemberTab) {
              this.$refs.rebateMemberTab.refresh();
            }
          });
          break
        case 'gameresultslots':
          this.currTab = 'gameresultslots'
          this.$nextTick(() => {
            if(this.$refs.gameResultSlotsTab) {
              this.$refs.gameResultSlotsTab.refresh();
            }
          });
          break
        case 'gameresultlivecasino':
          this.currTab = 'gameresultlivecasino'
          this.$nextTick(() => {
            if(this.$refs.gameResultLivecasinoTab) {
              this.$refs.gameResultLivecasinoTab.refresh();
            }
          });
          break
        case 'gameresultsportsbook':
          this.currTab = 'gameresultsportsbook'
          this.$nextTick(() => {
            if(this.$refs.gameResultSportsbookTab) {
              this.$refs.gameResultSportsbookTab.refresh();
            }
          });
          break
        case 'gameresultcockfight':
          this.currTab = 'gameresultcockfight'
          this.$nextTick(() => {
            if(this.$refs.gameResultCockfightTab) {
              this.$refs.gameResultCockfightTab.refresh();
            }
          });
          break
        case 'gameresultrescue':
          this.currTab = 'gameresultrescue'
          this.$nextTick(() => {
            if(this.$refs.gameResultRescueTab) {
              this.$refs.gameResultRescueTab.refresh();
            }
          });
          break
        case 'gameresultreward':
          this.currTab = 'gameresultreward'
          this.$nextTick(() => {
            if(this.$refs.gameResultRewardTab) {
              this.$refs.gameResultRewardTab.refresh();
            }
          });
          break
        case 'gameresultfreeslots':
          this.currTab = 'gameresultfreeslots'
          this.$nextTick(() => {
            if(this.$refs.gameResultFreeSlotsTab) {
              this.$refs.gameResultFreeSlotsTab.refresh();
            }
          });
          break
        case 'gameresultothers':
          this.currTab = 'gameresultothers'
          this.$nextTick(() => {
            if(this.$refs.gameResultOthersTab) {
              this.$refs.gameResultOthersTab.refresh();
            }
          });
          break
        case 'pendingbetlistwbet':
          this.currTab = 'pendingbetlistwbet'
          this.$nextTick(() => {
            if(this.$refs.pendingBetListWBetTab) {
              this.$refs.pendingBetListWBetTab.refresh();
            }
          });
          break
        case 'pendingbetlist9w':
          this.currTab = 'pendingbetlist9w'
          this.$nextTick(() => {
            if(this.$refs.pendingBetList9WTab) {
              this.$refs.pendingBetList9WTab.refresh();
            }
          });
          break
        case 'pendingbetlistothers':
          this.currTab = 'pendingbetlistothers'
          this.$nextTick(() => {
            if(this.$refs.pendingBetListOthersTab) {
              this.$refs.pendingBetListOthersTab.refresh();
            }
          });
          break
        case 'memberlinkage':
          this.currTab = 'memberlinkage'
          this.$nextTick(() => {
            if(this.$refs.memberLinkageTab) {
              this.$refs.memberLinkageTab.refresh();
            }
          });
          break
      }
    },
    tabChecking() {
      if(this.showActionButton('dailystatement')) {
        this.currTab = 'dailystatement'
        this.$nextTick(() => {
          if(this.$refs.dailyStatementTab) {
            this.$refs.dailyStatementTab.refresh();
          }
        });
      }
      else if(this.showActionButton('platformwinlose')) {
        this.currTab = 'platformwinlose'
        this.$nextTick(() => {
          if(this.$refs.platformWinLoseTab) {
            this.$refs.platformWinLoseTab.refresh();
          }
        });
      }
      else if(this.showActionButton('providerwinlosemember')) {
        this.currTab = 'providerwinlosemember'
        this.$nextTick(() => {
          if(this.$refs.providerWinLoseMemberTab) {
            this.$refs.providerWinLoseMemberTab.refresh();
          }
        });
      }
      else if(this.showActionButton('refereelist')) {
        this.currTab = 'refereelist'
        this.$nextTick(() => {
          if(this.$refs.refereeListTab) {
            this.$refs.refereeListTab.refresh();
          }
        });
      }
      else if(this.showActionButton('rebatemember')) {
        this.currTab = 'rebatemember'
        this.$nextTick(() => {
          if(this.$refs.rebateMemberTab) {
            this.$refs.rebateMemberTab.refresh();
          }
        });
      }
      else if(this.showActionButton('gameresultslots')) {
        this.currTab = 'gameresultslots'
        this.$nextTick(() => {
          if(this.$refs.gameResultSlotsTab) {
            this.$refs.gameResultSlotsTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultlivecasino')) {
        this.currTab = 'gameresultlivecasino'
        this.$nextTick(() => {
          if(this.$refs.gameResultLivecasinoTab) {
            this.$refs.gameResultLivecasinoTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultsportsbook')) {
        this.currTab = 'gameresultsportsbook'
        this.$nextTick(() => {
          if(this.$refs.gameResultSportsbookTab) {
            this.$refs.gameResultSportsbookTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultcockfight')) {
        this.currTab = 'gameresultcockfight'
        this.$nextTick(() => {
          if(this.$refs.gameResultCockfightTab) {
            this.$refs.gameResultCockfightTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultrescue')) {
        this.currTab = 'gameresultrescue'
        this.$nextTick(() => {
          if(this.$refs.gameResultRescueTab) {
            this.$refs.gameResultRescueTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultreward')) {
        this.currTab = 'gameresultreward'
        this.$nextTick(() => {
          if(this.$refs.gameResultRewardTab) {
            this.$refs.gameResultRewardTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultfreeslots')) {
        this.currTab = 'gameresultfreeslots'
        this.$nextTick(() => {
          if(this.$refs.gameResultFreeSlotsTab) {
            this.$refs.gameResultFreeSlotsTab.refresh();
          }
        });
      } else if(this.showActionButton('gameresultothers')) {
        this.currTab = 'gameresultothers'
        this.$nextTick(() => {
          if(this.$refs.gameResultOthersTab) {
            this.$refs.gameResultOthersTab.refresh();
          }
        });
      } else if(this.showActionButton('pendingbetlistwbet')) {
        this.currTab = 'pendingbetlistwbet'
        this.$nextTick(() => {
          if(this.$refs.pendingBetListWbetTab) {
            this.$refs.pendingBetListWbetTab.refresh();
          }
        });
      } else if(this.showActionButton('pendingbetlist9w')) {
        this.currTab = 'pendingbetlist9w'
        this.$nextTick(() => {
          if(this.$refs.pendingBetList9WTab) {
            this.$refs.pendingBetList9WTab.refresh();
          }
        });
      } else if(this.showActionButton('pendingbetlistothers')) {
        this.currTab = 'pendingbetlistothers'
        this.$nextTick(() => {
          if(this.$refs.pendingBetListOthersTab) {
            this.$refs.pendingBetListOthersTab.refresh();
          }
        });
      } else if(this.showActionButton('memberlinkage')) {
        this.currTab = 'memberlinkage'
        this.$nextTick(() => {
          if(this.$refs.memberLinkageTab) {
            this.$refs.memberLinkageTab.refresh();
          }
        });
      }
    },
    redirectReport(tab) {
      this.refresh(tab)
    }
  }
};
</script>